import { db } from '../firebase'

  const publishBillSyncRequest = (orderNumber, transporterId) => {
    const odooSyncPayload = {
            entity: 'BILL',
            order_number: orderNumber,
            transporter_id: transporterId
    }
    db.ref('odooSync').push().set(odooSyncPayload)
  }

  const publishBillBatchSyncRequest = (invoices, transporterId, batchId = '') => {
    const odooSyncPayload = {
            entity: 'BILL_BATCH',
            batch_id: batchId,
            invoices,
            transporter_id: transporterId
    }
    return db.ref('odooSync').push().set(odooSyncPayload)
  }

  export {publishBillSyncRequest, publishBillBatchSyncRequest}
